import { BASE_URL } from '../apis/confluence'
import proxy from '../apis/proxy'

const removeElements = (elms) => elms.forEach(el => el.remove());

const convertConfluenceHtml = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html")

  const anchors = doc.getElementsByTagName("a");
  for (let i = 0; i < anchors.length; i += 1) {
    // allow page navigation
    if (anchors[i].href.includes("pages/viewpage.action?pageId")) {
      anchors[i].href = `/page?title=${encodeURIComponent(
        anchors[i].innerText
      )}`
    }

    // allow page navigation by image
    if (anchors[i].href.includes("page?title=")) {
      const pageTitle = anchors[i].href.split('page?title=').pop();
      anchors[i].href = `/page?title=${pageTitle}`
    }

    // allow download of attachments
    if (anchors[i].href.includes("/download/attachments") && anchors[i].title === "Download") {
      const downloadLink = anchors[i].href.split('/download/').pop();
      anchors[i].href = `${proxy}${BASE_URL}/download/${downloadLink}`
      anchors[i].target = '_blank'
    }

    // remove ability to click on attachments table values such as column header for sorting, attachments, usernames
    if (anchors[i].href.includes("sortBy=name&sortOrder=ascending") || anchors[i].href.includes("sortBy=date&sortOrder=descending") ||
      anchors[i].className === "url fn confluence-userlink") {
      anchors[i].removeAttribute("href")
    }
  }

  // remove unnecessary elements from confluence page such as attachments table upload inputs, expandable columns
  removeElements(doc.querySelectorAll("div.plugin_attachments_upload_container"));
  removeElements(doc.querySelectorAll("th.expand-column"));
  removeElements(doc.querySelectorAll("td.attachment-summary-toggle"));
  removeElements(doc.querySelectorAll("tr.attachment-summary"));
  removeElements(doc.querySelectorAll("a.download-all-link"));
  removeElements(doc.querySelectorAll("fieldset.hidden"));
  removeElements(doc.querySelectorAll("span.aui-icon.content-type-attachment-image"));

  const images = doc.getElementsByTagName("img");
  for (let i = 0; i < images.length; i += 1) {
    // update image src so images show correctly
    if (images[i].src.includes("download/attachments/embedded-page")) {
      const downloadLink = images[i].src.split('/download/').pop();
      images[i].src = `${proxy}${BASE_URL}/download/${downloadLink}`
    }
  }

  return doc.body.innerHTML;
}

export default convertConfluenceHtml;
